// JS
import { useCallback, useEffect, useRef, useState } from 'react';
//import { useResizeDetector } from 'react-resize-detector';
import {
  //devOrProd,
  getInternationalPriceNuqlium,
  ppHeadingOverridesOpen,
  swapImg,
} from '../shared/utils';

// COMPS
import DiscountPrice from '../DiscountPrice';
import PhotoGalleryPopup from '../PhotoGalleryPopup';

// COMPONENT - THUMBNAIL
const Thumbnails = ({ images = [], imagesRef, centerRef, containerRef }) => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!centerRef.current || !containerRef.current) {
        return;
      }
      const i = Math.round(
        (window.scrollY - containerRef.current.offsetTop) /
          (centerRef.current.offsetHeight / images.length)
      );
      if (i < images.length) {
        setActive(i);
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [centerRef, containerRef, images.length]);

  const handleClick = (i) => {
    if (!centerRef.current || !containerRef.current) {
      return;
    }
    const imageHeight = centerRef.current.offsetHeight / images.length;
    // window.scroll({ behavior: 'smooth', top: containerRef.current.offsetTop + (i * imageHeight) })
    // Upper one scrolls so that selected image hits top of the screen, the bottom one is better UX, scolls in a way that selected image is in the center on Screen.
    window.scroll({
      behavior: 'smooth',
      top:
        containerRef.current.offsetTop +
        i * imageHeight -
        window.innerHeight / 2 +
        imageHeight / 2 +
        212,
    });
  };

  const arrowClick = (up = false) => {
    if (!centerRef.current || !containerRef.current) {
      return;
    }
    const i = active + (up ? -1 : 1);
    if (i < 0 || i >= images.length) {
      return;
    }
    const imageHeight = centerRef.current.offsetHeight / images.length;
    window.scroll({
      behavior: 'smooth',
      top:
        containerRef.current.offsetTop +
        i * imageHeight -
        window.innerHeight / 2 +
        imageHeight / 2,
    });
  };

  return (
    <div className="thumbnail-container" ref={imagesRef}>
      <span className="arrow-prev" onClick={() => arrowClick(true)} />
      {images.map((image, index) => (
        <img
          onClick={() => handleClick(index)}
          className={`thumbnail ${active === index && 'active'}`}
          key={index}
          src={image.src}
          alt={image.alt}
          fetchpriority="high"
        />
      ))}
      <span className="arrow-next" onClick={() => arrowClick(false)} />
    </div>
  );
};

// COMPONENT - DESKTOP SCROLL GALLERY
const PhotoGalleryDesktopScroll = ({
  blackFriday,
  data,
  text,
  images = data.product.attributes.alternatives.map((slide, i) => ({
    src: slide,
    alt: 'Photo Gallery: ' + data.product.name + ': ' + i,
  })),
  isSale,
  freeDelBadge,
  restockBadge,
  bfExcludedCategories,
}) => {
  const [showHideGalleryPopup, setShowHideGalleryPopup] = useState(false);
  const imagesRef = useRef(null);
  const desktopRef = useRef(null);
  const containerRef = useRef(null);
  const ref = useRef(null);

  const changeClasses = useCallback(() => {
    if (!(containerRef.current && imagesRef.current)) {
      return;
    }

    if (window.scrollY <= containerRef.current.offsetTop) {
      imagesRef.current.className = 'thumbnail-container';
      desktopRef.current.className = 'desktop-gallery-image';
      return;
    }

    const centerBottom =
      containerRef.current.offsetTop + containerRef.current.offsetHeight;
    const scrollBottom = window.scrollY + window.innerHeight;

    if (scrollBottom > centerBottom) {
      imagesRef.current.className = 'thumbnail-container thumbnail-fixed';
      desktopRef.current.className =
        'desktop-gallery-image desktop-gallery-image-scroll';
      return;
    }

    imagesRef.current.className = 'thumbnail-container thumbnail-fixed';
    desktopRef.current.className =
      'desktop-gallery-image desktop-gallery-image-scroll';
  }, []);

  /*
  const onResize = useCallback((width, height) => {
    changeClasses();
  });

  const { ref } = useResizeDetector({ onResize });
  */

  useEffect(() => {
    changeClasses(); //Handle page refresh
    window.addEventListener('scroll', changeClasses, { passive: true });
    return () => {
      window.removeEventListener('scroll', changeClasses);
    };
  }, [changeClasses]);

  return (
    <>
      {showHideGalleryPopup && (
        <PhotoGalleryPopup
          data={data}
          showHideGalleryPopup={showHideGalleryPopup}
          setShowHideGalleryPopup={setShowHideGalleryPopup}
        />
      )}
      <div className="desktop-gallery-container" ref={containerRef}>
        <Thumbnails
          containerRef={containerRef}
          images={images}
          imagesRef={imagesRef}
          centerRef={ref}
        />
        <div ref={ref} className="desktop-gallery-image-container">
          <div ref={desktopRef} className="desktop-gallery-image">
            <div className="flex flex-col gap-2 absolute z-10 top-5 left-5 empty:hidden">
              {blackFriday &&
                data.product.categorylist.includes('WEB_BLK_FRI') &&
                !bfExcludedCategories.some((el) =>
                  data.product.categorylist.includes(el)
                ) && <div className="desktop-image-BF-badge">25% Off</div>}

              {/*data.product.categorylist.includes('WEB_NIKE30') && (
                <div className="desktop-image-BF-badge">30% Off</div>
              )*/}

              {/*data.product.categorylist.includes('WEB_CP30') && (
                <div className="desktop-image-BF-badge">30% Off</div>
              )*/}

              {restockBadge &&
                data.product.categorylist.includes('WEB_FREEDELEXCL') && (
                  <div className="desktop-image-BF-badge re-stock">
                    Re-stock
                  </div>
                )}

              {freeDelBadge &&
                getInternationalPriceNuqlium() === 'retail_gbp' &&
                !data.product.categorylist.includes('WEB_LAUNCHES') &&
                data.product.option.priceasnumber >= 90 &&
                data.product.option.priceasnumber ===
                  data.product.option.promotionpriceasnumber && (
                  <div className="desktop-image-BF-badge free-delivery">
                    Free Standard Delivery
                  </div>
                )}

              {isSale ? (
                <DiscountPrice isSale={isSale} data={data} text={'Off'} />
              ) : (
                <DiscountPrice data={data} text={text} />
              )}
            </div>

            {data.product.attributes.alternatives.map((slide, i) => (
              <div
                className="desktop-gallery-image-wrapper"
                key={'photo-gallery[' + i + ']'}
              >
                <img
                  className="desktop-gallery-image-large"
                  src={`${swapImg(slide, 'medium', 'large')}`}
                  alt={'Photo Gallery: ' + data.product.name + ': ' + i}
                  fetchpriority={i === 0 ? 'high' : 'auto'}
                  onClick={(e) => {
                    e.preventDefault();
                    setShowHideGalleryPopup(true);
                    window.scrollLock();
                    ppHeadingOverridesOpen();
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default PhotoGalleryDesktopScroll;
